export * from './CopyText';
